/**
 * Get the url out of a photo comment, accepting the pre-okapi format, as well
 * as okapi photo and instagram comments.
 * @param {Object} profileComment - an object of profile comment info
 * @return {string|null} - the comment photo's url, if present
 */
export const getPhotoUrl = (profileComment) => {
	if (!profileComment || typeof profileComment !== "object") {
		return null;
	}

	if (
		profileComment &&
		profileComment.comment_content &&
		profileComment.comment_content.photos
	) {
		return profileComment.comment_content.photos.large;
	} else if (profileComment && profileComment.photo) {
		return profileComment.photo.square800;
	} else if (profileComment && profileComment.instagramPhoto) {
		return profileComment.instagramPhoto.square640;
	} else {
		return null;
	}
};

/**
 * Get the essay text out of an essay comment, accepting both the pre- and
 * okapi formatted comments.
 * @param {Object} profileComment - an object of profile comment info
 * @return {string|null} - the comment essay's text, if present
 */
export const getEssayText = (profileComment) => {
	if (!profileComment || typeof profileComment !== "object") {
		return null;
	}

	if (
		profileComment &&
		profileComment.comment_content &&
		profileComment.comment_content.essay_content
	) {
		return profileComment.comment_content.essay_content;
	} else if (profileComment && profileComment.essayText) {
		return profileComment.essayText;
	} else {
		return null;
	}
};



// WEBPACK FOOTER //
// ./src/shared/util/ProfileComment.js